import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import axios from "axios";
import "../css/newsblogpostdetail.css";
import ChatbotAi from "../components/ChatbotAi";
import { Helmet } from 'react-helmet-async';

const Blogs = () => {
    const { id: urlParamId } = useParams();
    const location = useLocation();
    const [post, setPost] = useState(null);
    const API_URL = process.env.REACT_APP_MainSite_API_URL;

    const [commentForm, setCommentForm] = useState({
        name: "",
        email: "",
        comment: "",
    });
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        if (location.state?.post) {
            const passedPost = location.state.post;

            const transformedPost = {
    id: passedPost.id,
   image: passedPost.imagePath
    ? `${process.env.REACT_APP_Dashboard_API_URL.split('/api')[0]}/${passedPost.imagePath}`
    : "https://placehold.co/800x400?text=No+Image",

    title: passedPost.heading,
    shortTagline: passedPost.subheading,
    tagline: passedPost.subheading,
    author: passedPost.author || "Unknown",
    date: passedPost.publishDate
        ? new Date(passedPost.publishDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
        })
        : "-",
    content: `<p>${passedPost.description}</p>`,
};


            setPost(transformedPost);
        } else {
            setPost(null);
        }

        window.scrollTo(0, 0);
    }, [location.state, urlParamId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'name') {
            if (/\d/.test(value)) {
                setErrors(prev => ({ ...prev, name: 'Please enter valid full name' }));
                return;
            } else {
                setErrors(prev => ({ ...prev, name: '' }));
            }
        }

        if (name === 'email') {
            if (value && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                setErrors(prev => ({ ...prev, email: 'Please enter a valid email address' }));
            } else {
                setErrors(prev => ({ ...prev, email: '' }));
            }
        }
        setCommentForm((prev) => ({ ...prev, [name]: value }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!commentForm.name.trim()) newErrors.name = 'Name is required';
        if (!commentForm.email.trim()) newErrors.email = 'Email is required';
        if (!commentForm.comment.trim()) newErrors.comment = 'Comment is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setSubmitting(true);
        try {
            await axios.post(`${API_URL}AddComment`, {
                blogId: post.id,
                name: commentForm.name,
                email: commentForm.email,
                comment: commentForm.comment
            });
            setSuccessMessage("Comment submitted successfully!");
            setCommentForm({ name: "", email: "", comment: "" });
            setTimeout(() => setSuccessMessage(''), 5000);
        } catch (error) {
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    if (!post) return <div className="newsblog-detail-container">Loading...</div>;

    return (
        <div className="newsblog-page">
            <Helmet>
                <title>{post.title} | Insurance Guidance & Insights | Policy Samjho</title>
                <meta
                    name="description"
                    content={`Read expert insurance insights on ${post.title}. Policy Samjho provides clarity on insurance policies, reviews, and personalized advice to help you stay protected.`}
                />
                <meta
                    name="keywords"
                    content="insurance guidance, policy consultation, insurance expert advice, insurance policy review, insurance advice India, understand insurance policy, insurance policy explanation"
                />
                <link rel="canonical" href={`https://policysamjho.com/blogs/${post.id}`} />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BlogPosting",
                        "headline": post.title,
                        "description": post.shortTagline || post.tagline,
                        "image": post.image,
                        "author": {
                            "@type": "Person",
                            "name": post.author
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": "Policy Samjho",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://policysamjho.com/policySamjhoFaviconLogo.png"
                            }
                        },
                        "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": `https://policysamjho.com/blogs/${post.id}`
                        }
                    })}
                </script>
            </Helmet>

            <div className="newsblog-hero-section" style={{ backgroundImage: `url(${post.image})` }}>
                <div className="newsblog-hero-overlay"></div>
                <div className="newsblog-hero-content">
                    <p className="newsblog-hero-tagline">{post.shortTagline || post.tagline}</p>
                    <h1 className="newsblog-hero-title">{post.title}</h1>
                </div>
            </div>

            <div className="newsblog-detail-container">
                <div className="newsblog-detail-content" dangerouslySetInnerHTML={{ __html: post.content }} />
                <div className="newsblog-interaction-section">
                    <div className="newsblog-comment-form">
                        <h4 className="newsblog-comment-heading">Leave a comment</h4>
                        <form onSubmit={handleSubmit}>
                            <div className="newsblog-form-row">
                                <div className="newsblog-form-group">
                                    <label htmlFor="name">Name</label>
                                    <input type="text" id="name" name="name" value={commentForm.name} onChange={handleChange} />
                                    {errors.name && <span className="error-text">{errors.name}</span>}
                                </div>
                                <div className="newsblog-form-group">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" id="email" name="email" value={commentForm.email} onChange={handleChange} />
                                    {errors.email && <span className="error-text">{errors.email}</span>}
                                </div>
                            </div>
                            <div className="newsblog-form-group">
                                <label htmlFor="comment">Comment</label>
                                <textarea id="comment" name="comment" rows="5" value={commentForm.comment} onChange={handleChange}></textarea>
                                {errors.comment && <span className="error-text">{errors.comment}</span>}
                            </div>
                            <button type="submit" className="newsblog-submit-comment-btn" disabled={submitting}>
                                {submitting ? "Submitting..." : "Submit Comment"}
                            </button>
                        </form>
                        {successMessage && <div className="success-text">{successMessage}</div>}
                    </div>
                </div>

                <div className="newsblog-detail-back-link">
                    <Link to="/home#latestnewsblog">&larr; Back to Latest News</Link>
                </div>
            </div>

            <ChatbotAi />
        </div>
    );
};

export default Blogs;